import Personnummer from 'personnummer';

export const ageResolver = (cpr: string) => {
  try {
    return Personnummer.parse(cpr, {
      allowCoordinationNumber: true,
      allowInterimNumber: false
    }).getAge();
  } catch (e) {
    return 0;
  }
};

export const isValidSSNOrCoordinationNumber = (cpr: string) => {
  try {
    return Personnummer.valid(cpr, {
      allowCoordinationNumber: true,
      allowInterimNumber: false
    });
  } catch (e) {
    return false;
  }
};

export const isVolontaryPhoneValid = (phoneNr: string) => {
  if (!phoneNr) {
    return true;
  }

  if (!/^[0-9]*$/.test(phoneNr)) {
    return false;
  }

  if (phoneNr.length < 9 || phoneNr.length > 10) {
    return false;
  }

  return true;
};
